
const urlQueries = getUrlQueries();

window.onload = async () => {
  let apiurl = `${theme.api.honda_api_domain}${theme.routes.ciam_auth_to_shopify}?code=${urlQueries["code"]}&href=${urlQueries["href"]}`;
  fetch(apiurl, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      "X-request-unique-key": crypto.randomUUID(),
      "X-api-key": theme.api.honda_api_key,
    },
  }).then(response => {
      return response.json();
  }).then(result => {
     if(result.resultCode=='000'){
       setCookie("id_token",result.idToken,theme.ciamTimeout.idToken);
       setCookie("session_token",result.accessToken,theme.ciamTimeout.accessToken);
       const hondaId = parseJwt(result.accessToken);
       setCookie("ciam_id",hondaId.sub,theme.ciamTimeout.hondaId);
       setCookie("refresh_token",result.refreshToken,theme.ciamTimeout.refreshToken);
       window.location.href = result.location;
     }
  });
}

function getUrlQueries() {
  var queryStr = window.location.search.slice(1);
  queries = {};

  if (!queryStr) {
    return queries;
  }

  queryStr.split("&").forEach(function (queryStr) {
    var queryArr = queryStr.split("=");
    queries[queryArr[0]] = decodeURIComponent(queryArr[1]);
  });

  return queries;
}
function setCookie(name,value,expiry) {
    var nameValue=escape (value);
    document.cookie = `${name}=${nameValue} ; max-age=${(expiry * 60 * 60)}; path=/`;
}
function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}